import { render, staticRenderFns } from "./ProducerList.html?vue&type=template&id=0af92ccf&external"
import script from "./ProducerList.ts?vue&type=script&lang=ts&external"
export * from "./ProducerList.ts?vue&type=script&lang=ts&external"
import style0 from "./ProducerList.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports